import {TSDokumentGrundTyp} from '../../../models/enums/TSDokumentGrundTyp';
import {TSDokumentTyp} from '../../../models/enums/TSDokumentTyp';

export const GS_DOKUMENT_ZU_UEBERNEHMEN_GROUPS: DokumentGrundTypeGroups = {
    EINKOMMENSVERSCHLECHTERUNG: [],
    ERWEITERTE_BETREUUNG: [
        TSDokumentTyp.BESTAETIGUNG_KITA_PLUS,
        TSDokumentTyp.BESTAETIGUNG_AUSSERORDENTLICHER_BETREUUNGSAUFWAND
    ],
    ERWERBSPENSUM: [
        TSDokumentTyp.NACHWEIS_ERWERBSPENSUM,
        TSDokumentTyp.AUSWEIS_ID,
        TSDokumentTyp.NACHWEIS_AUSBILDUNG,
        TSDokumentTyp.NACHWEIS_RAV,
        TSDokumentTyp.BESTAETIGUNG_ARZT,
        TSDokumentTyp.NACHWEIS_SELBSTAENDIGKEIT,
        TSDokumentTyp.NACHWEIS_ERWERBSPENSUM_UNREGELMAESSIG,
        TSDokumentTyp.NACHWEIS_FREIWILLIGENARBEIT,
        TSDokumentTyp.NACHWEIS_GESUNDHEITLICHE_INDIKATION,
        TSDokumentTyp.NACHWEIS_INTEGRATION_BESCHAEFTIGUNSPROGRAMM
    ],
    FAMILIENSITUATION: [
        TSDokumentTyp.NACHWEIS_TRENNUNG,
        TSDokumentTyp.UNTERSTUETZUNGSBESTAETIGUNG,
        TSDokumentTyp.AUSWEIS_ID,
        TSDokumentTyp.NACHWEIS_GETEILTE_OBHUT,
        TSDokumentTyp.NACHWEIS_UNTERHALTSVEREINBARUNG
    ],
    FINANZIELLESITUATION: [
        TSDokumentTyp.STEUERVERANLAGUNG,
        TSDokumentTyp.JAHRESLOHNAUSWEISE,
        TSDokumentTyp.NACHWEIS_FAMILIENZULAGEN,
        TSDokumentTyp.NACHWEIS_ERSATZEINKOMMEN,
        TSDokumentTyp.NACHWEIS_ERHALTENE_ALIMENTE,
        TSDokumentTyp.NACHWEIS_GELEISTETE_ALIMENTE,
        TSDokumentTyp.STEUERERKLAERUNG,
        TSDokumentTyp.NACHWEIS_VERMOEGEN,
        TSDokumentTyp.NACHWEIS_SCHULDEN,
        TSDokumentTyp.ERFOLGSRECHNUNGEN_JAHR,
        TSDokumentTyp.ERFOLGSRECHNUNGEN_JAHR_MINUS1,
        TSDokumentTyp.ERFOLGSRECHNUNGEN_JAHR_MINUS2,
        TSDokumentTyp.NACHWEIS_ABGERECHNETE_QUELLENSTEUERN,
        TSDokumentTyp.NACHWEIS_NETTOLOHN,
        TSDokumentTyp.NACHWEIS_EINKAEUFE_VORSORGE,
        TSDokumentTyp.NACHWEIS_ABZUEGE_LIEGENSCHAFT,
        TSDokumentTyp.NACHWEIS_HOEHERE_BEITRAEGE_BEEINTRAECHTIGUNG,
        TSDokumentTyp.NACHWEIS_BRUTTOLOHN,
        TSDokumentTyp.NACHWEIS_SOZIALHILFE,
        TSDokumentTyp.NACHWEIS_BRUTTOVERMOEGENERTRAEGE,
        TSDokumentTyp.NACHWEIS_GEWINNUNGSKOSTEN,
        TSDokumentTyp.NACHWEIS_SCHULDZINSEN,
        TSDokumentTyp.NACHWEIS_NETTOERTRAEGE_ERBENGEMEINSCHAFTEN,
        TSDokumentTyp.NACHWEIS_ERSATZINKOMMEN_SELBSTSTAENDIGKEIT_JAHR,
        TSDokumentTyp.NACHWEIS_ERSATZINKOMMEN_SELBSTSTAENDIGKEIT_JAHR_MINUS1,
        TSDokumentTyp.NACHWEIS_ERSATZINKOMMEN_SELBSTSTAENDIGKEIT_JAHR_MINUS2,
        TSDokumentTyp.NACHWEIS_LOHNAUSWEIS_1,
        TSDokumentTyp.NACHWEIS_LOHNAUSWEIS_2,
        TSDokumentTyp.NACHWEIS_LOHNAUSWEIS_3,
        TSDokumentTyp.NACHWEIS_EINKOMMEN_VERFAHREN
    ],
    FREIGABEQUITTUNG: [TSDokumentTyp.ORIGINAL_FREIGABEQUITTUNG],
    KINDER: [
        TSDokumentTyp.FACHSTELLENBESTAETIGUNG,
        TSDokumentTyp.ABSAGESCHREIBEN_HORTPLATZ
    ],
    PAPIERGESUCH: [TSDokumentTyp.ORIGINAL_PAPIERGESUCH],
    SONSTIGE_NACHWEISE: [TSDokumentTyp.DIV]
};

type DokumentGrundTypeGroups = Record<TSDokumentGrundTyp, TSDokumentTyp[]>;
